// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import styled from 'styled-components';
import { generateId } from './api/utility';
import { useGlobalState } from './globalState/GlobalStateProvider';

const Col = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0.2em;
`

const LocationList = ({ itemLocations, ...props }) => {
    const { state: {
        site_config,
    } } = useGlobalState();

    const locations = [];
    itemLocations.forEach(e => {
        if (site_config.locations.find(f => f.id === e)) locations.push(e)
    });

    if (locations.length === site_config.locations.length || !locations.length) return null;

    return (
        <Col>
            <b>Only at available Locations</b>
            {locations.map(e => <span key={generateId()}>{`- ${site_config.locations.find(f => f.id === e)?.city}`}</span>)}
        </Col>
    );
};

export default LocationList;